module.exports = __webpack_public_path__ + "static/media/delete~WVSNHOFR.4b780dec.svg";